import { Equipment, GymTypes } from 'fitbeat.models';
import { WorkoutSettings } from '../../entities';

export const STUDIO_ZONE_TO_INCLUDE_IN_STATIC_WORKOUTS = 3;

export function isStaticWorkout(gymType: GymTypes, workoutSettings: WorkoutSettings): boolean {
  const staticWorkoutEquipment = [Equipment.Bench, Equipment.Bodyweight, Equipment.Dumbbells, Equipment.Pushbells];
  return gymType === GymTypes.Home && workoutSettings.equipment
    && staticWorkoutEquipment.every((equipment) => workoutSettings.equipment.includes(equipment));
}
